import { Components, Theme } from "@mui/material";
import { WarningColors } from "style/Colors";

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    root: {
      color: WarningColors.base,
      fontWeight: "bold",
    },
  },
};
